import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    editButton: {
        minWidth: 0,
        flex: 1,
        margin: Theme.primaryMargin / 2,
        height: '50%',
        alignSelf: 'center'
    },
    buyMoreSpaceContainer: {
        height: '10%',
        paddingTop: 15,
        paddingHorizontal: 30,
        justifyContent: 'center'
    },
    buyMoreSpaceLink: {
        color: '#31C3F7',
        fontSize: 17,
        fontFamily: Theme.regularFont
    },
    editButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '24%',
        paddingHorizontal: Theme.primaryMargin,
        paddingVertical: 20
    }
};

export default StyleSheet.create(baseStyles);
